import React, {useEffect, useState, useRef} from 'react';
import PropTypes from 'prop-types';
import classnames from "classnames";
import uuid from 'react-uuid'

import {
  FormGroup,
  Input as BootstrapInput,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  UncontrolledTooltip
} from "reactstrap";

import { Typography } from "stories/components"

import './Input.css';

export const Input = ({ type, className, label, labelInline, focused, tooltip, helpText, errorText, required, children, ...rest }) => {
  
  const inputRef = useRef(null);
  const [inputUuid, setInputUuid] = useState()
  
  useEffect(() => {
    setInputUuid(uuid())
  }, [])
  
  useEffect(() => {
    // Define the wheel event listener
    const handleWheel = event => {
      event.preventDefault(); // Prevent scrolling
    };
    
    // Access the input DOM element and add a non-passive wheel event listener
    const inputElement = inputRef.current;
    if (inputElement != null) {
      inputElement.addEventListener('wheel', handleWheel, { passive: false });

      // Cleanup the event listener on component unmount
      return () => {
        inputElement.removeEventListener('wheel', handleWheel);
      };
    }
  }, [inputRef]); // Empty dependency array ensures this effect runs only once after initial render


  
  if (type === 'email') {
    return (
      <FormGroup
        className={classnames("mb-3", {
          focused: focused,
        })}
      >
        <div className={`d-flex ${labelInline ? "flex-row align-items-center" : "flex-column"}`}>
          {label && (
              <Typography bold className={`pr-1`}>{label} {required ? "*" : ""}</Typography>
          )}
          <InputGroup className="input-group-merge input-group-alternative">
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="ni ni-email-83" />
              </InputGroupText>
            </InputGroupAddon>
            <BootstrapInput
              placeholder="Email"
              type="email"
              className={className}
              {...rest}
            />
          </InputGroup>
        </div>
        { errorText && (
        <Typography className="text-danger">{errorText}</Typography>
        )}
      </FormGroup>
    )
  }
  else if (type === 'password') {
    return (
      <FormGroup className={classnames({
        focused: focused,
      })}>
        <div className={`d-flex ${labelInline ? "flex-row align-items-center" : "flex-column"}`}>
          {label && (
            <Typography bold className={`pr-1`}>{label} {required ? "*" : ""}</Typography>
          )}
          <InputGroup className="input-group-merge input-group-alternative">
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="ni ni-lock-circle-open" />
              </InputGroupText>
            </InputGroupAddon>
            <BootstrapInput
              placeholder="Password"
              type="password"
              className={className}
              {...rest}
            />
          </InputGroup>
        </div>
        { errorText && (
        <Typography className="text-danger">{errorText}</Typography>
        )}
      </FormGroup>
    )
  }
  else if (type === 'select') {
    return (
      <FormGroup className={`${classnames({
        focused: focused,
      })} mb-0`}>
        <div className={`d-flex ${labelInline ? "flex-row align-items-center" : "flex-column"}`}>
          {label && (
            <Typography bold className={`pr-1`}>{label} {required ? "*" : ""}</Typography>
          )}
          <BootstrapInput
            className={`sk_input_select ${className}`}
            label=""
            type="select"
            {...rest}
          >
          {children}
          </BootstrapInput>
        </div>
        { errorText && (
        <Typography className="text-danger">{errorText}</Typography>
        )}
      </FormGroup>
    )
  }
  else {
    return (
      <div className={`d-flex ${labelInline ? "flex-row align-items-center" : "flex-column"}`}>
        {label && (
          <Typography bold className={`pr-1`}>{label} {required ? "*" : ""}</Typography>
        )}
        <BootstrapInput
          className={`custom_bootstrap_input ${className}`}
          id={`id_${inputUuid ? inputUuid : "nouuid"}`}
          innerRef={inputRef}
          type={type ? type : "text"}
          {...rest}
        />
        { tooltip ? (
          <UncontrolledTooltip flip target={`id_${inputUuid ? inputUuid : "nouuid"}`}>{tooltip}</UncontrolledTooltip>
        ) : null }
        { helpText && (
          <Typography className="text-info">{helpText}</Typography>
        )}
        { errorText && (
          <Typography className="text-danger">{errorText}</Typography>
        )}
      </div>
    )
  }
  
  
};

Input.propTypes = {
  errorText: PropTypes.string,
  focused: PropTypes.bool,
  label: PropTypes.string,
  labelInline: PropTypes.bool,
  required: PropTypes.bool,
  type: PropTypes.oneOf(['text','email','password','number','date','datetime-local','select','textarea']),
};

Input.defaultProps = {
  focused: false,
  labelInline: false,
  required: false,
  type: 'text',
};
